import { useTranslation } from "react-i18next"

import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

/**
 * OKS-49 — Rank pill on the creator profile page.
 *
 * Per UX Spec §2.1:
 *   - Centred shadcn `Badge` (variant `default`, accent fill).
 *   - Single-line; truncates with ellipsis at <320px (the
 *     `aria-label` carries the full name for screen readers).
 *   - Non-interactive in v1 (no rank-detail Sheet exists).
 *
 * # Locked testid
 *
 *   - `rank-pill` — wrapper. Vitest asserts mount + label.
 */
interface RankPillProps {
  name: string
  className?: string
}

export function RankPill({ name, className }: RankPillProps) {
  const { t } = useTranslation()

  return (
    <Badge
      data-testid="rank-pill"
      data-rank-name={name}
      aria-label={t("rank.profile.pill_aria_label", { name })}
      className={cn(
        "max-w-full truncate px-3 py-1 text-sm font-medium",
        className,
      )}
    >
      {name}
    </Badge>
  )
}
